import React from 'react';
import { Link } from 'react-router-dom';
import { useForm, ValidationError } from '@formspree/react';
import thank from '../media/thank.jpg';
import '../styles/contact.css'
function Contact() {
  const [state, handleSubmit] = useForm("xnqyvjkp");

  const image = (
    <img style={{height:"200px", width: "200px" , borderRadius:"100%"}} src={thank} alt=""/>
    );
  if (state.succeeded) {
    return <div style={{ textAlign: 'center', height: '100vh', paddingTop:"350px" }} className="container">
      {image}
      <h4>Thanks for contacting me, I'll get back to you soon!</h4>
      <Link to='/' style={{ textDecoration: 'none' }}>Back Home</Link>
    </div>;
  }
  return (
    <div className='contact'>
      <div className="controlwidth">
        <h1 className="heading">
          Want to get in touch? <br />Find me on&nbsp;
          {/* <a href={"tel:+91-6387298440"} className="editContent" >phone</a>, */}
          <a href={"https://www.linkedin.com/in/rishabh-kumar-901a5a224/"} className="editContent">linkedin</a>,
          <a className='editContent' href={"https://github.com/RishabhS21"}> github</a>,
          <a href={"mailto:rishabhkumar.iitd.cs@gmail.com"} className="editContent"> email</a>,
          <a href={"https://www.instagram.com/surya_21rk/"} className="editContent"> instagram </a>
          or
          <a href={"https://www.facebook.com/profile.php?id=100009326008564"} className="editContent"> facebook</a>.
        </h1>
        <form onSubmit={handleSubmit}>
          <input
            id="name"
            type="name"
            name="name"
            placeholder='Your Name'
          />
          <ValidationError
            prefix="Name"
            field="name"
            errors={state.errors}
          />
          <input
            id="email"
            type="email"
            name="email"
            placeholder='Your Email'
          />
          <ValidationError
            prefix="Email"
            field="email"
            errors={state.errors}
          />
          <textarea
            id="message"
            name="message"
            placeholder='Message Here'
            rows={8}
          />
          <ValidationError
            prefix="Message"
            field="message"
            errors={state.errors}
          />
          <button style={{ margin: "8px 10px 8px 0" }} className="glow-on-hover" type="submit" disabled={state.submitting}><i className='bx bxl-telegram bx-tada bx-flip-horizontal' ></i><span className="send-text">SEND</span></button>
        </form>
      </div>
    </div>
  );
}

export default Contact;
